export class PaymentsApi {

    #client;

    /**
     * @param {ServerData} client
     * */
    constructor(client) {
        this.#client = client;
    }

    /**
     * @param {string} buildingId
     * @param {string} apartmentNumber
     * @param {number} year
     * @param {number | null} paymentPlanId
     * */
    getActivePaymentPlans(buildingId, apartmentNumber, year, paymentPlanId = null) {
        const resp = this.#client.get(`/managers/payments/${buildingId}/${apartmentNumber}/payment-plans/all-active/${year ?? 'all'}/${paymentPlanId ?? ''}`);
        return resp;
    }

    /**
     * @param {string} buildingId
     * @param {number[]} PaymentPlanDetailId
     * @param {{withoutInvalidate?: boolean}} [options]
     * @return {Promise<void>}
     * */
    stopPaymentPlanDetails(buildingId, PaymentPlanDetailId, options = {}) {
        let query = '';
        if (options.withoutInvalidate) {
            query += `withoutInvalidate=${options.withoutInvalidate}`;
        }
        const resp = this.#client.post(`/managers/payments/${buildingId}/payment-plan-details/stop?${query}`, { PaymentPlanDetailId });
        return resp;
    }

    /**
     * @param {string} buildingId
     * @param {{[key: number]: Date}} dates
     * @param {{withoutInvalidate?: boolean}} [options]
     * @return {Promise<void>}
     * */
    updateChargeDatesPaymentPlanDetails(buildingId, dates, options = {}) {
        let query = '';
        if (options.withoutInvalidate) {
            query += `withoutInvalidate=${options.withoutInvalidate}`;
        }
        const resp = this.#client.patch(`/managers/payments/${buildingId}/payment-plan-details/charge-date?${query}`, { ...dates });
        return resp;
    }


    /**
     * @param {string} buildingId
     * @param {number} year
     * @param {number} month
     * */
    getHashavshevetXmlBuildingData(buildingId, year, month) {
        const resp = this.#client.get(`/managers/cashflow/data/building/${buildingId}/${year}/${month}/hashavshevet_xml`);
        return resp;
    }

    /**
     * @param {string} buildingId
     * @param {number} year
     * @param {number} month
     * */
    getHashavshevetXmlPartnerData(partnerId, year, month) {
        const resp = this.#client.get(`/managers/cashflow/data/partner/${partnerId}/${year}/${month}/hashavshevet_xml`);
        return resp;
    }

    /**
     * @param {number | string} buildingId
     * @param {number} year
     * @param {object} tenantPaymentsJson
     * */
    uploadPaymentSettings(buildingId, year, tenantPaymentsJson) {
        const resp = this.#client.post(`/managers/payments/${buildingId}/${year}`, { tenantPaymentsJson }, { throwError: true });
        return resp;
    }

    /**
     * @typedef {{
     *     paymentId: number;
     *     paymentMethodId: number;
     *     bankChargeDetails: null | {
     *         bankCode: string;
     *         branchId: string;
     *         accountId: string;
     *     };
     *     creditCardDetails: null | {
     *         cardType: string;
     *         lastNums: string;
     *         expireDate: string;
     *     };
     *     wireDetails: null | {
     *         wireConfirmationNum: string;
     *         bankCode: string;
     *         branchId: string;
     *         accountId: string;
     *     };
     *     chequeDetails: null | {
     *         chequeNum: string;
     *         bankCode: string;
     *         branchId: string;
     *         accountId: string;
     *     };
     * }} PaymentInfo
     * */

    /**
     * @param {string|number} buildingId
     * @param {number} paymentId
     * @return {Promise<PaymentInfo>}
     * */
    getPaymentInfo(buildingId, paymentId) {
        const resp = this.#client.get(`/managers/payments/${buildingId}/info/${paymentId}`, {}, { throwError: true });
        return resp;
    }

}
